import mitt from 'mitt';

const EventBus = new mitt()

export default EventBus